import { useState } from 'react';
import TextInput from '../../../../../../common/components/atom/TextInput/TextInput'
import styles from './PoleCreateUpdateFormView.module.scss'
import MapComponent from '../../../../../../common/components/organisme/MapComponent/MapComponent';
import Button from '../../../../../../common/components/atom/Button/Button';
import { ErrorInputPole } from '../../../../utils/validationPole';

export interface DataForm {
    name?: string
    number?: string
    location?: {
        latitude?: number
        longitude?: number
    }

}

export interface PoleCreateUpdateFormViewProps {
    variant?: "dark" | "light"
    isUpdate?: boolean,
    labelSubmitBtn?: string
    isLoading?: boolean
    dataForm?: DataForm | null
    setDataForm?: (data: DataForm | null) => void
    handleSubmit?: () => void
    eroorMessage?: string,
    errorForm?: ErrorInputPole | null

}

export default function PoleCreateUpdateFormView({variant , isUpdate, errorForm, labelSubmitBtn = 'Créer', isLoading, dataForm, setDataForm, handleSubmit,eroorMessage}: PoleCreateUpdateFormViewProps) {
  const [location, setLocation] = useState<number[]>([0, 0]);
    return (

    <div className={[styles['container-form'], styles['container-form--'+variant]].join(" ")}>
      <p color='white'>{eroorMessage}</p>
     <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--name"],
        ].join(" ")}
      >
        <TextInput
              variant={variant}
          label="Nom"
          value={dataForm?.name}
          rows={10}
          onChange={(e) =>{
            setDataForm && setDataForm({...dataForm, name: e.target.value})
          }}

          error={errorForm?.isErrorName}
       
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--description"],
        ].join(" ")}
      >
        <TextInput
              variant={variant}
          label="Numéro"
       
          value={dataForm?.number}
          rows={10}
          onChange={(e) =>{
            setDataForm && setDataForm({...dataForm, number: e.target.value})
          }
          }
          error={errorForm?.isErrorNumber}
       
        />
      </div>
      <h2 className={styles["container-form__title-section"]}>Localisation</h2>

      <div
        className={[
          styles["container-form__section"],
          styles["container-form__section--location"],
        ].join(" ")}
      >
        <div>
          <div
            className={[
              styles["container-form__item"],
              styles["container-form__item--location"],
            ].join(" ")}
          >
            <TextInput
              variant={variant}
              label="Latitude"
            value={dataForm?.location?.latitude}
              onChange={(e) => {

                
                setDataForm && setDataForm({...dataForm, location: {latitude: parseFloat(e.target.value), longitude: location[1]}})
                setLocation([parseFloat(e.target.value), location[1]]);
      

                
              }}
              error={errorForm?.isErrorLat}
              type="number"
           
            />
          </div>
          <div
            className={[
              styles["container-form__item"],
              styles["container-form__item--location"],
            ].join(" ")}
          >
            <TextInput
                  variant={variant}
              label="Longitude"
              value={dataForm?.location?.longitude}
              
              onChange={(e) => {
                setDataForm && setDataForm({...dataForm, location: {latitude: location[0], longitude: parseFloat(e.target.value)}})
                setLocation([location[0], parseFloat(e.target.value)]);
              }}
              type="number"
              error={errorForm?.isErrorLng}
             
            />
          </div>
        </div>

        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--map"],
          ].join(" ")}
        >
          {location && location[0] && location[1] ? (
            <MapComponent
              center={location}
              zoom={10}
              pinList={[{ position: location, name: "Minigrid" }]}
              style={{ height: "100%", width: "100%", borderRadius: "20px" }}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className={styles["container-form__section"]}>
        <Button
          label={labelSubmitBtn}
          variant={"dark-parimary"}
          isLoading={isLoading}
          onClick={handleSubmit}
         
        />
      </div>
    </div>
  )
}
